import { createRoot } from 'react-dom/client'
import { Navigate, Route, Routes } from "react-router-dom";
import W2d2dApp from "./wd2d2/app/W2d2dApp.tsx";
import IdeasPage from "./wd2d2/app/pages/ideas/IdeasPage";
import { W2d2dNavigation } from "./wd2d2/W2d2dNavigation.tsx";
import AppFwWrapper from "./appfw/AppFwWrapper.tsx";
import AuthenticationGuard from "./appfw/authentication/AuthenticationGuard";
import SplashScreenOutlet from "./wd2d2/app/SplashScreenOutlet";
import EditIdeaPage from "./wd2d2/app/pages/ideas/edit/EditIdeaPage";
import IdeaPage from "./wd2d2/app/pages/ideas/IdeaPage";
import EditIdeaRoute from "./wd2d2/app/pages/ideas/edit/EditIdeaRoute";
import JoinIdeaRoute from "./wd2d2/app/pages/ideas/join/JoinIdeaRoute";
import AnnounceIdeaRoute from "./wd2d2/app/pages/ideas/announce/announce-idea-route.tsx";
import ConnectionsPage from "./wd2d2/app/pages/connections/ConnectionsPage";
import InvitationPage from "./wd2d2/app/pages/invitations/InvitationPage";
import SettingsPage from "./wd2d2/app/pages/settings/SettingsPage";
import AppFwOverlay from "./appfw/ui/layouts/AppFwOverlay.tsx";
import AppFwLayout from "./appfw/ui/layouts/AppFwLayout.tsx";
import { AppFwContext } from "./appfw/AppFwContext.ts";
import EventsFeedPage from "./wd2d2/app/pages/events/EventsFeedPage.tsx";
import EventView from "./wd2d2/app/pages/events/event-view.tsx";
import PodsSettingsPage from "./wd2d2/app/pages/settings/pods/pods-settings-page.tsx";


if ('serviceWorker' in navigator) {

    window.addEventListener('load', async () => {
        // de-register all unknown service-workers
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const registration of registrations) {
            const scriptURL = registration.active?.scriptURL || '';
            console.log("[SW] Check service worker:", scriptURL);
            if (!scriptURL.includes('/sw.js')) {
                console.log('[SW] found old service worker:', scriptURL, ' ➔ unregister...');
                await registration.unregister();
            }
        }

        // 2. Neuer Service Worker aktiviert → Seite hart neu laden
        // navigator.serviceWorker.addEventListener('controllerchange', () => {
        //     // TODO: update dialog? ==> needs also change on service worker side
        //     console.log('[SW] Neuer Service Worker aktiv – Seite wird neu geladen.');
        //     window.location.reload();
        // });
    });
}


// TODO: => W2d2dAppRoutes.tsx
let AppRoutes =
    <Routes>
        <Route element={<W2d2dApp />}>

            // overlay routes
            <Route path={W2d2dNavigation.ideas.add.path} element={
                <AppFwOverlay title="Idee vorschlagen" forceClose>
                    <EditIdeaPage />
                </AppFwOverlay>
            } />

            <Route path={W2d2dNavigation.ideas.idea(":id").path} element={
                <AppFwOverlay title="Idee">
                    <IdeaPage />
                </AppFwOverlay>}>
            </Route>

            <Route path={W2d2dNavigation.ideas.idea(":id").edit.path} element={
                <AppFwOverlay title="Idee bearbeiten" forceClose>
                    <EditIdeaRoute />
                </AppFwOverlay>
            } />

            <Route path={W2d2dNavigation.ideas.idea(":id").join.token(":token").path} element={
                <AppFwOverlay title="Idee" forceClose>
                    <JoinIdeaRoute />
                </AppFwOverlay>
            } />

            <Route path={W2d2dNavigation.ideas.idea(":id").announce.path} element={
                <AppFwOverlay title="Benachrichtigen" forceClose>
                    <AnnounceIdeaRoute />
                </AppFwOverlay>
            } />

            <Route path={W2d2dNavigation.invitations.invitation(":id").path} element={
                <AppFwOverlay title="Einladung" forceClose>
                    <InvitationPage />
                </AppFwOverlay>
            } />

            <Route path={W2d2dNavigation.events.event(":encodedUri").path} element={
                <AppFwOverlay title="Veranstaltung" avatar={false}>
                    <EventView />
                </AppFwOverlay>
            } />

            // layout routes
            <Route element={<AppFwLayout />}>
                <Route index path={W2d2dNavigation.ideas.path} element={<IdeasPage />} />
                <Route index path={W2d2dNavigation.events.path} element={<EventsFeedPage />} />
                <Route path={W2d2dNavigation.connections.path} element={<ConnectionsPage />} />
                <Route path={W2d2dNavigation.settings.path} element={<SettingsPage />} />
                <Route path={W2d2dNavigation.settings.pods.path} element={<PodsSettingsPage />} />
            </Route>
        </Route>

        {/* Global not found route => general 404 page + specific 404 pages */}
        <Route path="*" element={<Navigate to={W2d2dNavigation.ideas.path} replace />} />
    </Routes>

const appFwContext = new AppFwContext({
    appName: "w2d2d",
    authentication: {
        oidcProviders: ["google", "apple"],
    },
    notifications: {
        vapidPublicKey: 'BFt1UtTVorcl5mfz-ZMEcML3KQ36JmYaDJodUMPgNV1Y44pfrAojC6A5Etp0kn7sXHh_EbNIDfTQbwd6GnGqLuA',
    }
})


const node = document.getElementById('root') as HTMLElement
createRoot(node).render(
    <AppFwWrapper appFwContext={appFwContext}>
        <AuthenticationGuard splashScreenOutlet={<SplashScreenOutlet />}>
            {AppRoutes}
        </AuthenticationGuard>
    </AppFwWrapper>
)